export type DeployState =
  | { status: 'NOT_IN_ARGO' }
  | { status: 'DISABLED' }
  | { status: 'PR_PENDING_ADD'; prUrl: string; prNumber: number }
  | { status: 'PR_PENDING_REMOVE'; prUrl: string; prNumber: number }
  | { status: 'ENABLED' };

export interface RepoDeployInfo {
  repoName: string;
  state: DeployState;
  entityRef: string;
  owner: string | null;
  system: string | null;
  canDeploy: boolean;
}

/** Fails type-checking when a switch over a union misses a case. */
export function assertNever(value: never): never {
  throw new Error(`Unexpected value: ${JSON.stringify(value)}`);
}

/**
 * Names a deploy status this build doesn't know, such as one added by a newer
 * backend. Its `never` parameter still fails type-checking for a missed case.
 */
export function unknownStatus(state: never): string {
  return String((state as { status?: unknown }).status ?? 'unknown');
}
